import React from 'react';
import 'moment/locale/it';
import { UIModal, UIModalBody, UIModalButtons, UiModalInternal } from '../../utilities/Modal';
import { UIFormControlBox } from '../../utilities/Form';
import { Box } from '@chakra-ui/react';
import DropzoneFormikInput from '../../utilities/Dropzone';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { UIPageHeader } from '../../utilities/Headers';
import { UIButton } from '../../utilities/Button';
import { IconCheck } from '@tabler/icons-react';
import { useAccounts } from '../../../hooks/Accounts/useAccounts';
import { UiDialog } from '../../utilities/Dialog';

const ModalDoctorsBulk = ({ modalOpen, handleModalClose }) => {
  const [operationLoading, setOperationLoading] = React.useState(false);
  const [resultMode, setResultMode] = React.useState(false);
  const [resultLink, setResultLink] = React.useState(null);
  const [resultSuccess, setResultSuccess] = React.useState(false);
  const [resultFailed, setResultFailed] = React.useState(false);
  const [filename, setFilename] = React.useState(null);
  const { onCreateDoctorsBulkAdmin } = useAccounts();

  const handleModalCloseInternal = () => {
    handleModalClose();
  };

  const handleSubmit = (values) => {
    const { doctors_file } = values;
    setOperationLoading(true);

    onCreateDoctorsBulkAdmin({
      doctors_file
    }).then((res) => {
      if (res?.link) {
        setResultLink(res?.link);
        setResultSuccess(res?.created);
        setResultFailed(res?.failed);
        setResultMode(true);
      } else {
        setResultMode(false);
        setOperationLoading(false);
      }
    });
  };

  return (
    <UIModal open={modalOpen} onClose={handleModalCloseInternal} allowFullScreen={true} className={'modal'}>
      <UiDialog
        type={'file_result'}
        variant={'confirm'}
        title={`${resultSuccess} creati. ${resultFailed} non creati. Scarica il file di risultato`}
        open={resultMode}
        labelConfirm={'Scarica'}
        onClose={() => {
          setResultMode(false);
          setOperationLoading(false);
        }}
        onConfirm={() => {
          window.open(resultLink, '_blank');
        }}
      />
      <UiModalInternal onClose={handleModalCloseInternal} isLoading={false} isOperationLoading={operationLoading}>
        <Formik
          enableReinitialize={false}
          initialValues={{
            doctors_file: null
          }}
          validationSchema={Yup.object().shape({
            doctors_file: Yup.mixed().required('Il file è obbligatorio')
          })}
          onSubmit={(values) => handleSubmit(values)}
        >
          {({ errors, handleSubmit, touched, submitForm, setFieldValue }) => (
            <form onSubmit={handleSubmit} id={'appointment-form'}>
              <UIModalBody
                sx={{
                  bgcolor: 'transparent'
                }}
              >
                <UIPageHeader
                  title={'Caricamento multiplo dottori tramite file csv'}
                  sx={{
                    mt: 6,
                    textAlign: 'center'
                  }}
                />
                <UIFormControlBox
                  label={'File template'}
                  sx={{
                    mt: 2
                  }}
                >
                  <Box width={'100%'} display={'flex'} justifyContent={'start'} alignItems={'center'}>
                    <UIButton variant={'copy'} label={'Download template'} onClick={() => {
                      window.open('https://skinboost-prod.fra1.cdn.digitaloceanspaces.com/templates/Import%20Medici%20-%20Template.csv', '_blank');
                    }} />
                  </Box>
                </UIFormControlBox>

                <UIFormControlBox
                  label={'Import csv'}
                  error={Boolean(touched.doctors_file && errors.doctors_file)}
                  error_message={errors?.doctors_file}
                  sx={{
                    mt: 2
                  }}
                >
                  <Box display={'flex'} justifyContent={'start'} alignItems={'center'} gap={5}>
                    <DropzoneFormikInput
                      variant={'doctors_bulk'}
                      callback={(link) => {
                        setFilename(link?.split('/').pop().split('_').pop());
                      }}
                      setFieldValue={setFieldValue}
                      field={'doctors_file'}
                      folder={'doctors'}
                      label={'Carica file'}
                      type={'csv'}
                    />
                    <Box>{filename}</Box>
                  </Box>
                </UIFormControlBox>

              </UIModalBody>
              <UIModalButtons>
                <UIButton
                  type={'submit'}
                  onClick={() => submitForm()}
                  icon={<IconCheck stroke={'1.64'} size={'26px'} />}
                />
              </UIModalButtons>
            </form>
          )}
        </Formik>
      </UiModalInternal>
    </UIModal>
  );
};
export default ModalDoctorsBulk;
